import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { AppProvider } from './AppContext';
import './styles/theme.scss';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-toastify/dist/ReactToastify.css';
import 'react-phone-input-2/lib/style.css'
import "katex/dist/katex.min.css";
import { AuthProvider } from './utils/authProvider';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { Provider } from 'react-redux';
import {store, persistor} from './store/index';
import { PersistGate } from 'redux-persist/integration/react';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
    <GoogleOAuthProvider clientId="844469935573-g4enkpjoneao8veamqukeg9j9cl9erjj.apps.googleusercontent.com">
      <AuthProvider>
        <AppProvider>
          <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
              <App />
            </PersistGate>
          </Provider>
        </AppProvider>
      </AuthProvider>
    </GoogleOAuthProvider>
  // </React.StrictMode>
);
